module.exports = __webpack_public_path__ + "img/RubyMine_icon.7fca4fe3.png";